// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5133 ? "user-status-modal" : chunkId) + "-" + chunkId + ".js?v=" + {"640":"19a5506f19df079e3812","2983":"1f728bb13d4fd80b6bef","5133":"0a8f005c703a51b9a169","9279":"460048c8db22e016b900"}[chunkId] + "";
};